import ResetPasswordPage from './ResetPasswordPage';
export default ResetPasswordPage;



// WEBPACK FOOTER //
// ./src/modules/onboarding/pages/reset-password/index.js